<template>
  <div class="index">
    <div class="backgrond common_backgroundImg">
      <div class="header">
        <div class="header_box common_content">
          <div class="header_left">{{ title }}</div>
          <div class="header_right">
            <div v-if="logonStatus">
              <span @click="login">登录</span>
              <span>|</span>
              <span @click="register">注册</span>
            </div>
            <div v-if="userStatus">
              <p>
                <span @click="perCenter">
                  <i class="el-icon-user-solid"></i>
                  {{
                    userRole == 1
                      ? "运动员"
                      : userRole == 2
                      ? "考评员"
                      : userRole == 3
                      ? "测试机构"
                      : ""
                  }}
                  {{
                    personalInfo
                      ? userRole == 1 || userRole == 2
                        ? personalInfo.name
                        : userRole == 3
                        ? personalInfo.mechanism_fullName
                        : ""
                      : "" | ellipsis
                  }}
                </span>
                <span @click="message" style="cursor: pointer">
                  <i
                    class="el-icon-s-comment"
                    style="color: #f56c6c; font-size: 17px"
                  ></i>
                  <a
                    style="
                      color: #f56c6c;
                      position: relative;
                      left: -2px;
                      top: -1px;
                      font-size: 15px;
                    "
                    >消息{{ totalCount ? "(" + totalCount + ")" : "" }}</a
                  >
                </span>
                <span @click="out()" style="cursor: pointer">退出</span>
              </p>
            </div>
            <p v-if="loginStatus">
              <span></span>
              <span style="display: inline-block">我已经有账户,现在就</span>
              <router-link to="/signin">
                <a style="display: inline-block; color: #ea0000">登录</a>
              </router-link>
            </p>
          </div>
        </div>
      </div>
      <div class="banner common_content">
        <!-- <div class="banner_photo block"></div> -->
        <div class="banner_logo"></div>
        <!-- <div class="banner_ball block"></div>
        <div class="people block"></div>-->
      </div>
      <navigation />
    </div>
    <div class="content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <div class="foot">
      <foot :content="$route.meta.bottomFlag" />
    </div>
  </div>
</template>

<script>
import navigation from "@/views/admin/components/navigation.vue";
import foot from "@/views/admin/components/foot.vue";
import { mapGetters } from "vuex";
import { getStore } from "@/util/store";
import { GetStationNewsList } from "@/api/admin/common.js";
export default {
  components: {
    navigation,
    foot,
  },
  computed: {
    ...mapGetters(["userInfo", "userToken", "userRole", "personalInfo"]),
  },
  data() {
    return {
      title: "欢迎来到羽毛球运动水平等级评定!",
      logonStatus: true,
      userStatus: false,
      loginStatus: false,
      time: null,
      totalCount: 0,
      paging2: {
        limit: 6,
        page: 1,
        status: 1,
      },
    };
  },
  watch: {
    userToken(val) {
      if (!val) {
        this.logonStatus = true;
        this.userStatus = false;
        this.loginStatus = false;
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.time);
  },
  created() {
    this.$store.commit("SET_USERIFNO", getStore({ name: "userInfo" }));
    this.$store.commit("SET_USERTOKEN", getStore({ name: "userToken" }));
    this.$store.commit("SET_USERROLE", getStore({ name: "userRole" }));
    this.$store.commit("SET_PERSONALINFO", getStore({ name: "personalInfo" }));
    this.$store.dispatch("GetPersonalInfo", getStore({ name: "userInfo" }));

    if (this.userToken) {
      this.$store.dispatch("GetCheckApply", getStore({ name: "userInfo" }));
      this.logonStatus = false;
      this.userStatus = true;
      this.loginStatus = false;
    } else {
      this.logonStatus = true;
      this.userStatus = false;
      this.loginStatus = false;
    }
    this.interval();
    this.time = setInterval(() => {
      this.interval();
    }, 60000);
  },
  methods: {
    interval() {
      if (this.userToken) {
        GetStationNewsList(Object.assign(this.paging2)).then((data) => {
          var list = data.data.result;
          if (list) {
            this.totalCount = list.totalCount;
          }
        });
      }
    },
    login() {
      this.logonStatus = false;
      this.userStatus = false;
      this.loginStatus = false;
      this.$router.push({ path: "/signin" });
    },
    register() {
      this.$router.push({ path: "/register" });
      this.logonStatus = false;
      this.userStatus = false;
      this.loginStatus = true;
    },
    out() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("loginOut");
        this.$router.push({ path: "/signin" });
      });
    },
    perCenter() {
      this.$router.push({ path: "/personal" });
    },
    message() {
      this.$router.push({ path: "/message" });
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  /*width: 100%;*/
  //background: url(/image/index/group2.png);
  background: url(/image/new/body-bg.jpg);
  background-position: top center;
  background-repeat: no-repeat;
  /*background-position:50% 0px;*/
  .backgrond {
    /* 背景1 4 */
    width: 100%;
    // background: url(/image/index/group.png) center no-repeat;
    // height: 400px;
    .header {
      width: 100%;
      height: 42px;
      line-height: 42px;
      left: 0px;
      top: 0px;
      background: rgba(244, 244, 244, 0.85);
      .header_box {
        display: flex;
        justify-content: space-between;
        .header_left {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          color: #000000;
        }
        .header_right {
          span:nth-child(odd) {
            cursor: pointer;
          }
          span:nth-child(odd):hover {
            opacity: 0.5;
          }
          span:nth-child(even) {
            padding: 0px 10px;
          }
        }
      }
    }
    .banner {
      height: 200px;
      position: relative;
      .banner_photo {
        position: absolute;
        width: 460px;
        height: 200px;
        top: 0px;
        left: 0px;
        background: url(/image/index/headPhoto.png);
        background-size: cover;
        background-repeat: no-repeat;
      }
      .banner_logo {
        /* logo 1 */
        position: absolute;
        width: 600px;
        height: 100px;
        left: 35%;
        top: 50px;
        margin-left: -150px;
        //background: url(/image/index/logo.png);
        background: url(/image/new/title.png);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
      }
      .banner_ball {
        /* 羽毛球 1 */
        position: absolute;
        width: 90px;
        height: 90px;
        right: 50%;
        top: 52px;
        margin-right: -257px;
        background: url(/image/index/Badminton.png);
        transform: rotate(21.35deg);
        background-size: cover;
      }
      .people {
        /* 那羽毛球拍的人 1 */
        position: absolute;
        width: 212px;
        height: 237px;
        right: 0px;
        top: 0px;
        background: url(/image/index/people.png);
        background-size: cover;
        background-repeat: no-repeat;
        transform: matrix(-1, 0, 0, 1, 0, 0);
      }
    }
    width: 100%;
    .content {
      position: relative;
    }
  }
}
@media screen and (max-width: 1024px) {
  .index {
    .backgrond {
      .banner {
        height: 100px;
        .banner_logo {
          left: 32%;
          top: 6px;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .index {
    background: none;
    .backgrond {
      position: relative;
      background: none;
      .header {
        position: relative;
        height: 35px;
        line-height: 35px;
        .header_left {
          display: none;
        }
        .header_right {
          position: absolute;
          right: 15px;
          span {
            font-size: 14px;
            i {
              font-size: 16px;
            }
            a {
              font-size: 14px !important;
            }
          }
        }
      }
      .banner {
        height: 70px;
        .banner_logo {
          height: 43px;
          background-size: contain;
          width: 220px;
          left: 0;
          top: 14px;
          margin-left: 0;
        }
      }
    }
    .block {
      display: none;
    }
  }
}
</style>
<style lang="less">
@media screen and (max-width: 767px) {
  .el-message-box {
    width: auto !important;
  }
  .el-message {
    min-width: auto !important;
  }
  .el-notification {
    width: auto !important;
  }
}
</style>
